// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ_CONTACT_BUY_IN_eshop = "K\u00fap na %(eshop)s";
export const BZ_CONTACT_CALL_phone = "Zavolaj na %(phone)s";
export const BZ_CONTACT_CALL_phone_OR_BUY_IN_eshop = "Zavolaj na %(phone)s alebo k\u00fap na %(eshop)s";
export const BZ_CONTACT_OR_BUY_IN_eshop = "alebo k\u00fap na %(eshop)s";
export const BZ_CONTACT_OR_CALL_phone = "alebo zavolaj na %(phone)s";
export const BZ_CONTACT_OR_CALL_phone_AND_BUY_IN_eshop = "alebo zavolaj na %(phone)s a k\u00fap na %(eshop)s";
export const BZ_CONTACT_OR_CALL_phone_AND_SEE_IN_eshop = "alebo zavolaj na %(phone)s a pozri na %(eshop)s";
export const BZ_CONTACT_OR_SEE_IN_eshop = "alebo pozri na %(eshop)s";
export const BZ_CONTACT_OR_sendmsg = "alebo %(sendmsg)s";
export const BZ_CONTACT_OR_sendmsg_AND_CALL_phone = "alebo %(sendmsg)s a zavolaj na %(phone)s";
export const BZ_CONTACT_OR_sendmsg_AND_CALL_phone_AND_SEE_IN_eshop = "alebo %(sendmsg)s, zavolaj na %(phone)s a pozri na %(eshop)s";
export const BZ_CONTACT_OR_sendmsg_AND_SEE_IN_eshop = "alebo %(sendmsg)s a pozri na %(eshop)s";
